/**
 *
 */
(function () {
    "use strict";

    window.addEventListener("load", function(){
        window.cookieconsent.initialise({
            "palette": {
                "popup": {
                    "background": "#252e39"
                },
                "button": {
                    "background": "#14a7d0"
                }
            },
            "content": {
                "message": "Ta strona internetowa używa plików cookies (tzw. ciasteczka) w celach statystycznych, reklamowych oraz funkcjonalnych. Dzięki nim możemy indywidualnie dostosować stronę do twoich potrzeb. Każdy może zaakceptować pliki cookies albo ma możliwość wyłączenia ich w przeglądarce.",
                "dismiss": "Zgadzam się",
                "link": "Dowiedz się więcej",
                "href": "/strona/regulamin"
            }
    })});

    $('[data-type="add-comment"]').click(function () {
        var $elm = $(this);
        $.ajax({
            method: "POST",
            url: "/api/latest/comment/add",
            data: JSON.stringify({
                documentId: $elm.data('document-id'),
                nick: $('input[name="nick"]').val(),
                text: $('textarea[name="text"]').val()
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        }).done(function( response, textStatus, jqXHR ) {
            $('form.comments-form').remove();
            $('.comments__inner').append('<p>Twój komentarz został dodany i oczekuje na moderację.</p>')
        }).fail(function( jqXHR, textStatus, errorThrown ) {
            $('.comment__error').remove();
            if (typeof jqXHR.responseJSON.errors !== "undefined") {
                for (var key in jqXHR.responseJSON.errors) {
                    if (jqXHR.responseJSON.errors.hasOwnProperty(key)) {
                        for (var i = 0; i < jqXHR.responseJSON.errors[key].length; i++) {
                            var error = jqXHR.responseJSON.errors[key][i];
                            $('[data-input="' + key + '"]').after('<span class="comment__error">' + error + '</span>');
                        }
                    }
                }
            }
        });

        return false;
    });
})();